module.exports = __webpack_public_path__ + "static/media/hardware.3fc859b0.gif";